"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireWildcard(require("ui-box"));

var _typography = require("../../typography");

var _theme = require("../../theme");

var CheckIcon = function CheckIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      props = (0, _objectWithoutProperties2.default)(_ref, ["fill"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7"
  }, props), _react.default.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"
  }));
};

CheckIcon.displayName = "CheckIcon";
CheckIcon.propTypes = {
  fill: _propTypes.default.string
};

var MinusIcon = function MinusIcon(_ref2) {
  var _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? 'currentColor' : _ref2$fill,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["fill"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"
  }));
};

MinusIcon.displayName = "MinusIcon";
MinusIcon.propTypes = {
  fill: _propTypes.default.string
};

var Checkbox =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Checkbox, _PureComponent);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIndeterminate", function (el) {
      if (!el) return;
      el.indeterminate = _this.props.indeterminate;
    });
    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          id = _this$props.id,
          name = _this$props.name,
          label = _this$props.label,
          appearance = _this$props.appearance,
          disabled = _this$props.disabled,
          isInvalid = _this$props.isInvalid,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          value = _this$props.value,
          indeterminate = _this$props.indeterminate,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "id", "name", "label", "appearance", "disabled", "isInvalid", "checked", "onChange", "value", "indeterminate"]);
      var themedClassName = theme.getCheckboxClassName(appearance);
      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({
        is: "label",
        cursor: disabled ? 'not-allowed' : 'pointer',
        position: "relative",
        display: "flex",
        marginY: 16
      }, props), _react.default.createElement(_uiBox.default, {
        className: themedClassName,
        is: "input",
        id: id,
        type: "checkbox",
        name: name,
        value: value,
        checked: checked || indeterminate,
        onChange: onChange,
        disabled: disabled,
        "aria-invalid": isInvalid,
        innerRef: this.setIndeterminate
      }), _react.default.createElement(_uiBox.default, {
        boxSizing: "border-box",
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 16,
        height: 16
      }, indeterminate ? _react.default.createElement(MinusIcon, null) : _react.default.createElement(CheckIcon, null)), label && _react.default.createElement(_typography.Text, {
        marginLeft: 8,
        size: 300,
        color: disabled ? 'muted' : 'default'
      }, label));
    }
  }]);
  return Checkbox;
}(_react.PureComponent);

Checkbox.displayName = "Checkbox";
(0, _defineProperty2.default)(Checkbox, "propTypes", (0, _objectSpread2.default)({}, _uiBox.spacing.propTypes, _uiBox.position.propTypes, _uiBox.layout.propTypes, _uiBox.dimensions.propTypes, {
  /**
   * The id attribute of the checkbox.
   */
  id: _propTypes.default.string,

  /**
   * The id attribute of the radio.
   */
  name: _propTypes.default.string,

  /**
   * Label of the checkbox.
   */
  label: _propTypes.default.node,

  /**
   * The value attribute of the radio.
   */
  value: _propTypes.default.string,

  /**
   * The checked attribute of the radio.
   */
  checked: _propTypes.default.bool,

  /**
   * State in addition to "checked" and "unchecked".
   * When true, the radio displays a "minus" icon.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * Function called when state changes.
   */
  onChange: _propTypes.default.func,

  /**
   * When true, the radio is disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * When true, the aria-invalid attribute is true.
   * Used for accessibility.
   */
  isInvalid: _propTypes.default.bool,

  /**
   * The appearance of the checkbox.
   * The default theme only comes with a default style.
   */
  appearance: _propTypes.default.string,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired
}));
(0, _defineProperty2.default)(Checkbox, "defaultProps", {
  checked: false,
  indeterminate: false,
  onChange: function onChange() {},
  appearance: 'default'
});

var _default = (0, _theme.withTheme)(Checkbox);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/checkbox/src/Checkbox.js
// module id = 148
// module chunks = 0